export default {"src":"/_next/static/media/arrow-down.80216f1c.svg","height":12,"width":12};